module.exports = __webpack_public_path__ + "static/media/swiss_timing_sy.109909f8.png";